// API Configuration
// In production/staging (when served by Rails), use same-origin. Override with REACT_APP_API_URL if needed.
const getBaseUrl = () => {
  if (process.env.REACT_APP_API_URL) return process.env.REACT_APP_API_URL;
  if (process.env.NODE_ENV === 'production') return ''; // Same-origin when Rails serves the app
  return 'http://localhost:8888';
};

export const API_CONFIG = {
  BASE_URL: getBaseUrl(),
  API_VERSION: '/api/v1',
  FULL_BASE_URL: getBaseUrl() + '/api/v1'
};

// Timeout (ms)
// - Defaults: 30s in development, 10s otherwise
// - Override via REACT_APP_API_TIMEOUT_MS
const DEFAULT_TIMEOUT_MS = process.env.NODE_ENV === 'development' ? 30000 : 10000;
export const API_TIMEOUT_MS = (() => {
  const raw = process.env.REACT_APP_API_TIMEOUT_MS;
  const parsed = raw ? Number(raw) : Number.NaN;
  return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_TIMEOUT_MS;
})();

// Axios configuration
export const axiosConfig = {
  baseURL: API_CONFIG.FULL_BASE_URL,
  timeout: API_TIMEOUT_MS,
  headers: {
    'Content-Type': 'application/json',
  }
};
